import {StringUtil} from "src/app/util/StringUtil";
import {QueryCondition} from "src/app/model/QueryCondition";
import {DecisionInput} from "src/app/model/DecisionInput";
import {ReviewResult} from "src/app/constant/Enums";

export namespace Validator {

    export function validateDecision(decision: DecisionInput) {
        const {reason, reviewResult} = decision;
        if (ReviewResult.NO_ACTION == reviewResult || ReviewResult.RE_OPENED == reviewResult ||
            ReviewResult.RE_INSTATED == reviewResult || ReviewResult.NO_RE_INSTATED == reviewResult) {
            return;
        }
        if (StringUtil.isNullOrEmpty(reason)) {
            return "reason code is required!";
        }
    }

    export function validateQueryCondition(queryCondition: QueryCondition) {
        const {referenceSubType, caseType, caseSubType, reviewType, country, reviewStatus, startDate, endDate} = queryCondition;
        if (StringUtil.isNullOrEmpty(referenceSubType)) {
            return "referenceSubType is required!"
        }

        if (StringUtil.isNullOrEmpty(caseType)) {
            return "caseType is required!"
        }

        if (StringUtil.isNullOrEmpty(caseSubType)) {
            return "caseSubType is required!"
        }

        if (StringUtil.isNullOrEmpty(reviewType)) {
            return "reviewType is required!"
        }

        if (StringUtil.isNullOrEmpty(country)) {
            return "country is required!"
        }

        if (StringUtil.isNullOrEmpty(reviewStatus)) {
            return "reviewStatus is required!"
        }

        if (StringUtil.isNullOrEmpty(startDate)) {
            return "startDate is required!"
        }

        if (StringUtil.isNullOrEmpty(endDate)) {
            return "endDate is required!";
        }
    }

    export function validateDateRange(startStr: string, endStr: string, dayRangeLimit: number) {
        const range = calculateDateDifference(startStr, endStr);
        if (range > dayRangeLimit) {
            return "Date range should not greater than " + dayRangeLimit;
        }
    }

    function calculateDateDifference(startStr: string, endStr: string): number {
        const date1 = new Date(startStr);
        const date2 = new Date(endStr);
        const differenceInMilliseconds = Math.abs(date2.getTime() - date1.getTime());
        const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 60 * 60 * 24));

        return differenceInDays;
    }
}